const angular = require('angular');

const olyCommonModuleName = 'oly.common';

angular.module(olyCommonModuleName, []);

// ------------------------------------------
// Components
// ------------------------------------------
require('./accessibility');
require('./autocomplete');
require('./confirmation-dialog');
require('./disablepanel/');
require('./dropdown');
require('./error-src');
require('./lazy-load-component');
require('./filters');
require('./form');
require('./form-validation-summary');
require('./geolocation');
require('./googlemaps');
require('./grabfocus');
require('./guid/');
require('./hidescroll');
require('./hovermenu');
require('./input');
require('./loading-spinner');
require('./location');
require('./mask');
require('./memoscroll');
require('./movefocus');
require('./notification');
require('./numeric');
require('./onblur');
require('./ontouchend');
require('./openwindow');
require('./paging');
require('./postcode');
require('./resources');
require('./scrollbar');
require('./select');
require('./serializeasync');
require('./slideup');
require('./sticky');
require('./tooltip');
require('./transcludeinject');
require('./urlinfo');
require('./viewmore');
require('./maxlengthcounter');
require('./breadcrumbs');

module.exports = olyCommonModuleName;



// WEBPACK FOOTER //
// ./src/olycommon/olycommon.module.js